import { Injectable } from '@angular/core';
import Dexie, { Table } from 'dexie';
import { GhUserProfileDto } from '../api/generated/administration/models/gh-user-profile-dto';
import { SyncOperation } from './sync-operation.model';

export type UserProfileCache = {
  id: string;
  profile: GhUserProfileDto;
  syncedAt: string;
};

export type HttpCacheEntry = {
  key: string;
  body: unknown;
  cachedAt: string;
  ttlMs: number;
};

export type MetaEntry = {
  key: string;
  value: string;
};

@Injectable({ providedIn: 'root' })
export class OfflineDb extends Dexie {
  syncQueue!: Table<SyncOperation, string>;
  httpCache!: Table<HttpCacheEntry, string>;
  userProfile!: Table<UserProfileCache, string>;
  meta!: Table<MetaEntry, string>;

  constructor() {
    super('amc-portal-offline');
    this.version(1).stores({
      syncQueue: 'id, status, nextAttemptAt, entityType, entityId, createdAt',
      httpCache: 'key, cachedAt',
      userProfile: 'id',
      meta: 'key',
    });
  }
}
